// extracted by mini-css-extract-plugin
export default {"icon":"IconContrast_icon__PzMcw"};